import { faSave } from "@fortawesome/free-solid-svg-icons";
import { type FC, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const AddWhitelistedEmailModal: FC<{}> = (props) => {
  const { addWhitelistedEmail } = useApiCall();
  const refresh = useRefresh();
  const [email, setEmail] = useState<string>("");
  const [errors, setErrors] = useState<string[]>([]);

  const save = async () => {
    await addWhitelistedEmail(email).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    refresh();
  };

  return (
    <>
      <div>
        <Input
          type={"email"}
          placeholder={"email"}
          value={email}
          onChange={setEmail}
          label={"Email"}
        />
      </div>
      <ModalFooter text={"Opslaan"} icon={faSave} onSubmit={save} />
    </>
  );
};
